import { render, staticRenderFns } from "./SPRSimpleNumberInput.vue?vue&type=template&id=845b4298"
import script from "./SPRSimpleNumberInput.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleNumberInput.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleNumberInput.vue?vue&type=style&index=0&id=845b4298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports